import { render, staticRenderFns } from "./labbtns.vue?vue&type=template&id=0f4f683c&"
import script from "./labbtns.vue?vue&type=script&lang=js&"
export * from "./labbtns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports